import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=7b16163b&scoped=true&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16163b",
  null
  
)

component.options.__file = "Select2.vue"
export default component.exports